export const cronPresets = [
  { key: '5min', label: 'Cada 5 min', cron: '0 */5 * * * *' },
  { key: '15min', label: 'Cada 15 min', cron: '0 */15 * * * *' },
  { key: '30min', label: 'Cada 30 min', cron: '0 */30 * * * *' },
  { key: '1h', label: 'Cada hora', cron: '0 0 * * * *' },
  { key: '6h', label: 'Cada 6 horas', cron: '0 0 */6 * * *' },
  { key: '12h', label: 'Cada 12 horas', cron: '0 0 */12 * * *' },
  { key: 'daily9', label: 'Diario 9:00', cron: '0 0 9 * * *' },
  { key: 'daily21', label: 'Diario 21:00', cron: '0 0 21 * * *' },
  { key: 'custom', label: 'Personalizado', cron: '' },
];

export const describeCron = (cron, presets = cronPresets) => {
  const preset = presets.find(p => p.cron === cron);
  if (preset) return preset.label;
  return cron;
};
